import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { serverUrl } from "utils/utils";
import "./css/ForecastTable.css";
import { useUserContext } from "context/UserContext";
import { toast } from "react-toastify";
import { FaStar, FaRegStar } from "react-icons/fa";

const CryptoInsights = () => {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [watching, setWatching] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const { userDetails, setUserDetails, token } = useUserContext();
  useEffect(() => {
    if (userDetails?.watchList) {
      setWatching(userDetails.watchList);
    }
  }, [userDetails]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${serverUrl}/user/getForecasts`);
        const filtered = res.data.filter(
          (c) =>
            c.currentPrice !== undefined &&
            c.predictedLow !== undefined &&
            c.predictedHigh !== undefined &&
            c.stability !== undefined &&
            c.profitability !== undefined
        );
        setCoins(filtered);
      } catch (error) {
        console.error("Error fetching forecast:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  const sortedCoins = [...coins].sort((a, b) => {
    const { key, direction } = sortConfig;
    if (!key) return 0;

    const valA = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
    const valB = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];

    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  });
  const handleAdd = async (symbol) => {
    try {
      let res = await axios.put(
        `${serverUrl}/user/addToWatchList`,
        { symbol },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setWatching((prev) => [...prev, symbol]);
      if (res.data.success) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Failed to add to watchlist", err);
    }
  };

  const handleRemove = async (symbol) => {
    try {
      let res = await axios.delete(`${serverUrl}/user/removeFromWatchList`, {
        data: { symbol },
        headers: { Authorization: `Bearer ${token}` },
      });
      setWatching((prev) => prev.filter((s) => s !== symbol));
      if (res.data.success) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Failed to remove from watchlist", err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="forecast-container">
        <h2 className="forecast-title">דירוג 100 המטבעות המובילים לפי תחזיות</h2>

        {loading ? (
          <div className="loading-container">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">טוען...</span>
            </div>
          </div>
        ) : (
          <div className="table-wrapper">
            <table className="forecast-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th onClick={() => handleSort("name")} className="sortable">
                    שם
                  </th>
                  <th onClick={() => handleSort("symbol")} className="sortable">
                    סימול
                  </th>
                  <th onClick={() => handleSort("currentPrice")} className="sortable">
                    מחיר נוכחי ($)
                  </th>
                  <th onClick={() => handleSort("predictedLow")} className="sortable">
                    תחזית ירידה ($)
                  </th>
                  <th onClick={() => handleSort("predictedHigh")} className="sortable">
                    תחזית עלייה ($)
                  </th>
                  <th onClick={() => handleSort("stability")} className="sortable">
                    יציבות
                  </th>
                  <th onClick={() => handleSort("profitability")} className="sortable">
                    רווחיות
                  </th>
                  <th>סיבות</th>
                  <th>מעקב</th>
                </tr>
              </thead>

              <tbody>
                {sortedCoins.map((coin, index) => {
                  const isWatching = watching.includes(coin.symbol);
                  return (
                    <tr key={coin.symbol}>
                      <td>{index + 1}</td>
                      <td>{coin.name || "-"}</td>
                      <td>{coin.symbol || "-"}</td>
                      <td>{+coin.currentPrice.toFixed(4)}</td>
                      <td>{+coin.predictedLow.toFixed(4)}</td>
                      <td>{+coin.predictedHigh.toFixed(4)}</td>
                      <td className={coin.stability > 0.95 ? "text-success" : "text-warning"}>
                        {(coin.stability * 100).toFixed(2)}%
                      </td>
                      <td className={coin.profitability > 0.05 ? "text-profit" : "text-loss"}>
                        {(coin.profitability * 100).toFixed(2)}%
                      </td>
                      <td className="text-start reason-cell">{coin.reason || "-"}</td>
                      <td>
                        <button
                          className={`watchlist-btn btn btn-sm d-inline-flex align-items-center gap-1 ${
                            isWatching ? "btn-danger" : "btn-outline-primary"
                          }`}
                          onClick={() =>
                            isWatching ? handleRemove(coin.symbol) : handleAdd(coin.symbol)
                          }
                        >
                          {isWatching ? <FaStar /> : <FaRegStar />}
                          {isWatching ? "הסר" : "הוסף"}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default CryptoInsights;
